<template>
  <li>
    <div class="row">
      <div class="date col-xs-6 col-sm-4 col-md-3 col-lg-2">
        {{ date }}
      </div>
      <div class="source col-xs-6 col-sm-4 col-md-4 col-lg-2">
        {{ reference }}
      </div>
      <div class="amount col-xs-12 col-sm-4 col-md-5 col-lg-8 text-right">
        {{ paid }}
      </div>
    </div>
  </li>
</template>

<script>
  import moment from 'moment'
  import accounting from 'accounting'

  export default {
    props: ['payment'],

    computed: {
      date () {
        return moment(this.payment.paid_date).format('DD/MM/YYYY')
      },

      paid () {
        return accounting.formatMoney(this.payment.amount_paid)
      },

      reference () {
        return this.payment.reference
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvoicePaymentItem.vue?7da4356c